import React, { useState } from 'react';
import { useDrop } from 'react-dnd';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Pagination from '@mui/material/Pagination';
import { Application, ApplicationStatus, CollectedProps, DragItem, SortType } from 'pages/Vacancy/VacancyPage';
import DraggableRow from 'components/DraggableRow';
import MarkunreadIcon from '@mui/icons-material/Markunread';
import FavoriteIcon from '@mui/icons-material/Favorite';
import HeartBrokenIcon from '@mui/icons-material/HeartBroken';

import styles from './styles.module.scss';

interface ApplicationItemProps {
  status: ApplicationStatus;
  applications: Application[];
  sortBy: SortType;
  page: number;
  totalPages: number;
  onSortChange: (status: ApplicationStatus, sort: SortType) => void;
  onPageChange: (status: ApplicationStatus, page: number) => void;
  onDropApplication: (id: number, newStatus: ApplicationStatus, fromStatus: ApplicationStatus) => void;
}

export default function ApplicationItem({
  status,
  applications,
  sortBy,
  page,
  totalPages,
  onSortChange,
  onPageChange,
  onDropApplication,
}: ApplicationItemProps) {
  const [isActive, setActive] = useState<SortType>('final_score');
  const [{ isOver, canDrop }, drop] = useDrop<DragItem, void, CollectedProps>({
    accept: 'APPLICATION',
    drop: (item) => {
      if (item.fromStatus !== status) {
        onDropApplication(item.application.id, status, item.fromStatus);
      }
    },
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const title = {
    ANALYSED: 'Неразобранные',
    HOLD: 'Интересные',
    REJECTED: 'Отклонённые',
  }[status];

  const handleSortChange = (sort: SortType) => {
    onSortChange(status, sort)
    setActive(sort)
  };

  const generateDefaultText = (title: string) => {
    if (title === 'Неразобранные') {
      return 'Здесь появятся новые отклики кандидатов на вашу вакансию'
    }
    if (title === 'Интересные') {
      return 'Перетащите сюда отклики кандидатов, которые вас заинтересовали'
    }

     if (title === 'Отклонённые') {
      return 'Перетащите сюда отклики кандидатов, которые вам не подходят'
    }
  }

  const generateDefaultIcon = (title: string) => {
    if (title === 'Неразобранные') {
      return <MarkunreadIcon />
    }
    if (title === 'Интересные') {
      return <FavoriteIcon />;
    }

     if (title === 'Отклонённые') {
      return <HeartBrokenIcon />;
    }
  }


  return (
    <div className={styles.applicationWrapper}>
      <h3>{title}</h3>
      <div ref={drop} className={`${styles.tableSection} ${isOver && canDrop ? styles.dropActive : ''}`}>
        {applications.length === 0 ? (
          <div>
            <div className={styles.fakeTableHeader}>
              <p>Кандидат</p>
              <p>Резюме</p>
              <p>Тест</p>
              <p>Итог</p>
            </div>
            <div className={styles.emptyWrapper}>
              <p>{generateDefaultText(title)}</p>
              {generateDefaultIcon(title)}
            </div>
          </div>
          ) : (
          <table className={styles.table}>
            <thead>
              <tr className={styles.tableTrTh}>
                <th className={styles.tableThName}>Кандидат</th>
                <th className={isActive === 'resume_score' ? styles.activeTh : ''} onClick={() => handleSortChange('resume_score')}>
                  Резюме <span><ArrowDownwardIcon /></span>
                </th>
                <th className={isActive === 'test_score' ? styles.activeTh : ''} onClick={() => handleSortChange('test_score')}>
                  Тест <span><ArrowDownwardIcon /></span>
                </th>
                <th className={isActive === 'final_score' ? styles.activeTh : ''} onClick={() => handleSortChange('final_score')}>
                  Итог <span><ArrowDownwardIcon /></span>
                </th>
              </tr>
            </thead>
              <tbody>
                {applications.map(app => (
                  <DraggableRow key={app.id} application={app} fromStatus={status} />
                ))}
              </tbody>
          </table>
            )}

      </div>
      <div className={styles.pagination}>
        <Pagination
          page={page}
          count={totalPages}
          defaultPage={1}
          siblingCount={1}
          onChange={(_, newPage) => {
            if (page !== newPage) {
              onPageChange(status, newPage);
            }
          }}
        />
      </div>
    </div>
  );
}